<template>
  <div id="special_services">
    <slider-section id="normal-cards" :obj="servicesRepo" method="getPage" sliderHolder="specialServices" :data="info" :key="key" />
  </div>
</template>

<script>
import SliderSection from '../../components/sections/SliderSection'
import ServicesRepository from '../../repositories/servicesRepository'
import $ from 'jquery'
export default {
  name: 'SpecialServices',
  components: { SliderSection },
  data () {
    return {
      servicesRepo: new ServicesRepository(),
      info: {
        main: { sectionId: 'special_services', cardType: 'basic', title: this.$t('specialServices.title'), description: this.$t('specialServices.desc'), image: '' },
        slider: []
      },
      page: 0,
      size: 5,
      totalElements: 0,
      show: false,
      error: false,
      visited: [0],
      shouldBeDragged: 0,
      key: 0
    }
  },
  created () {
    this.$watch(() => {
      return this.$store.state.selectedNumber
    }, (val) => {
      this.key++
    })
  },
  mounted () {
    this.arabic()
  },
  methods: {
    arabic () {
      if (this.$lang === 'ar') {
        // this.info.main.image = 'bundlesArabic.png'
        $('#special_services').addClass('ar')
      } else {
        $('#special_services').addClass('en')
      }
    }
  }
}
</script>

<style scoped>
#special_services.ar {
  background: url("../../assets/images/circles-back-en.png") #F2F2F2 no-repeat;
}
#special_services.en {
  background: url("../../assets/images/circles-back-ar.png") #F2F2F2 no-repeat right;
}
</style>
